export const CommsTypeDropdown = [
  {
    label: "RF",
    value: "RF",
  },
  {
    label: "LORA",
    value: "LORA",
  },
  {
    label: "SIGFOX",
    value: "SIGFOX",
  },
  {
    label: "GSM",
    value: "GSM",
  },
  {
    label: "NB-IOT",
    value: "NBIOT",
  },
  {
    label: "NONE",
    value: "NONE",
  },
];
